module.exports = __webpack_public_path__ + "static/media/disappearing-earth.0231195f.jpg";